import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

export interface DatePipeOptions {
    format?: string;
    prefix?: string;
    postfix?: string;
    local?: boolean;
}

@Pipe({ name: 'csmsDate' })
export class DatePipe implements PipeTransform {
    transform(value: string | number | Date, options: DatePipeOptions = {}): any {
        const format = options.format || 'YYYY-MM-DD HH:mm:ss.SSS';
        if (value == null) {
            return '';
        }
        const date = moment.utc(value);

        if (!date.isValid()) {
            return value;
        }

        if (options.local || options.local === undefined) {
            date.local();
        }

        return `${options.prefix || ''}${date.format(format)}${options.postfix || ''}`;
    }
}
